import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Callout } from '@treams/treams-ui';

const Link = styled.a`
	color: inherit;
	text-decoration: underline;
`;

export default function HelpLink(props: { id: string }) {
	const { t } = useTranslation();
	const [visible, setVisible] = useState(true);

	if (!visible) {
		return null;
	}

	return (
		<Callout
			color="blue"
			onDismiss={() => setVisible(false)}
			description={
				<Link href={t(`${props.id}.link`)} target="_blank" rel="noreferrer">
					{t(`${props.id}.text`)}
				</Link>
			}
		/>
	);
}
